import React from "react"
import { apiIsLoggedIn } from "../api/api.js"
import LogoutButton from "../components/buttons/LogoutButton.jsx"

class LoginRequiredTest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            testSucceeded: false,
        }
    }

    componentDidMount() {
        apiIsLoggedIn().then(isLoggedIn => {
            this.setState({
                testSucceeded: isLoggedIn,
            });
        });
    }

    render() {
        return (
            <div className="login-required-test">
                <h1>Login Required Test</h1>
                <p>This is a test page that requires login.</p>
                <p>Current value of login is: {this.state.testSucceeded.toString()}</p>
                { this.state.testSucceeded ? (
                    <LogoutButton />
                ) : (
                    <div></div>
                )}
            </div>
        );
    }
}

export default LoginRequiredTest;
